<div class="spinner" style="--spinner-size: {{ spinnerSize }}px"></div>
